import { supabase } from '../../lib/supabaseClient';

/** Invite un contact au portail client (crée le compte + envoie l'email). */
export async function inviteClientToPortal(contactId: string, dossierId?: string): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Non authentifié');

  const { data, error } = await supabase.functions.invoke<{ client_user_id: string }>(
    'invite-client',
    {
      body: { contact_id: contactId, dossier_id: dossierId ?? null },
      headers: { Authorization: `Bearer ${session.access_token}` },
    },
  );
  if (error) throw error;
  if (!data?.client_user_id) throw new Error('Réponse invalide du serveur');
}

/** Renvoie l'email d'invitation à un client déjà inscrit. */
export async function resendClientInvitation(contactId: string, dossierId?: string): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Non authentifié');

  const { error } = await supabase.functions.invoke('resend-client-invitation', {
    body: { contact_id: contactId, dossier_id: dossierId ?? null },
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  if (error) throw error;
}

/**
 * Indique si un contact a déjà un compte portail (lecture client_users).
 * NOTE : la policy RLS client_users_select_self autorise un admin à lire toutes
 * les lignes ; un avocat non-admin ne verra PAS la ligne et obtiendra `false`
 * même si un compte existe. Acceptable pour PR2 — au pire l'avocat clique
 * « Inviter », l'Edge Function renvoie 409 « a déjà un accès », l'UI l'affiche.
 */
export async function contactHasPortalAccess(contactId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('client_users')
    .select('id')
    .eq('contact_id', contactId)
    .maybeSingle();
  if (error) throw error;
  return !!data;
}
